<template>
  <div>
    <custom-text :msg="customText" :customValue="studentData" class="mt-3"></custom-text>
    <v-container grid-list-sm>
      <v-layout row wrap pt-3 class="table-padding">
        <v-flex xs7 class="body-2">
          {{$t('assessments_title_module')}}
        </v-flex>
        <v-flex xs3 class="hidden-xs-only body-2">
          {{$t('assessments_title_date')}}
        </v-flex>
        <v-flex xs2 class="text-left body-2">
          {{$t('assessments_title_grade')}}
        </v-flex>
      </v-layout>
      <student-assessments-row class="expansion-panel-custom" :active="active"/>
      <div v-if="assessmentsLoadedNoResults" class="info info-text info-message">
        {{$t('assessments_empty_list')}}
      </div>
    </v-container>
  </div>
</template>

<script>
  import {
    GET_STUDENT_ASSESSMENTS_LIST
  } from '../../store/action-types'
  import { mapState, mapActions } from 'vuex'
  import StudentAssessmentsRow from './StudentAssessmentsRow'
  import CustomText from '../help/CustomText'
  import Roles from '../../mixins/Roles'

  export default {
    components: {StudentAssessmentsRow, CustomText},
    name: 'student-assessments',
    props: ['studentId', 'active'],
    mixins: [Roles],
    data () {
      return {}
    },
    methods: {
      ...mapActions({
        getAssessments: GET_STUDENT_ASSESSMENTS_LIST
      }),
      loadData () {
        this.getAssessments(this.studentId)
      }
    },
    computed: {
      assessmentsLoadedNoResults () {
        return (!this.assessmentsLoading) && (this.studentAssessments.length === 0)
      },
      ...mapState({
        studentAssessments: state => state.assessments.studentAssessments,
        assessmentsLoading: state => state.assessments.assessmentsLoading,
        studentData: state => state.student
      }),
      customText () {
        let role = this.isAdmin ? 'admin' : (this.isStaff ? 'staff' : 'student')
        return 'custom-text.' + role + '.assessments'
      }
    },
    watch: {
      active (value) {
        if (value) {
          this.loadData()
        }
      }
    },
    mounted () {
      if (this.active) {
        this.loadData()
      }
    }
  }
</script>

<style scoped>
  .table-padding {
    padding-left: 24px;
    padding-right: 48px;
  }

  .info-message {
    padding: 1em;
    text-align: center;
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/student/StudentAssessments.vue